<template>
    <div id="vendors-items-container">
        <div class="row">
            <div class="col-12">
                <h4 class="page-title text-truncate">{{ $t('Shared.Therapy') }}</h4>
                <div class="row">
                    <div class="col-sm-12 col-md-3" v-if="hasPermissionAdd()">
                        <MdButton
                            v-bind:Label="$t('MdNote.AddTherapy')"
                            v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-on:click="AddTherapy"
                            v-bind:Name="'btn_add_vendor'"
                        >
                        </MdButton>
                    </div>

                    <div
                        v-bind:class="
                            hasPermissionAdd()
                                ? 'col-sm-12 col-md-6 mb-4'
                                : 'col-sm-12 col-md-12 mb-4'
                        "
                    >
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input
                                    type="text"
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="parameter.SearchCriteria"
                                    @keyup.enter="SearchTherapy"
                                />
                                <div class="input-group-append">
                                    <div class="input-group-append">
                                        <MdButton
                                            v-bind:Name="'btnsearchinput'"
                                            v-bind:VariantProp="'btn btn-sm search-attached'"
                                            v-bind:IconClass="'mdi mdi-magnify'"
                                            v-on:click="SearchTherapy"
                                        >
                                        </MdButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        v-bind:class="
                            hasPermissionAdd()
                                ? 'col-sm-12 col-md-3 mb-4'
                                : 'col-sm-12 col-md-12 mb-4'
                        "
                    >
                        <MdLookup
                            v-bind:ModelCode="parameter.categoryCode"
                            v-bind:ModelDescription="categoryName"
                            v-bind:Label="$t('Shared.Category')"
                            v-bind:RefCode="'category'"
                            v-bind:Api="'Categories'"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'name'"
                            :SearchTitle="$t('Shared.Category')"
                            :GetValues="onCodeConditionOk"
                            :InvalidFeedback="$t('ModalCategory.fBakInvCatMsg')"
                            :SearchFieldCode="'Code'"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mt-2">
                <MdTitle
                    v-bind:Text="$t('Shared.SearchResult')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
                <div class="row">
                    <div class="col-md-12">
                        <MdTable
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:isReadOnly="isReadOnly"
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            :editIconEvent="EditTherapy"
                            v-bind:VisibleEditIcon="hasPermissionEdit()"
                            :deleteIconEvent="RemoveTherapy"
                            v-bind:VisibleDeleteIcon="hasPermissionDelete()"
                            :onRowSelected="onRowSelected"
                            :onFiltered="onFiltered"
                            :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction"
                        >
                        </MdTable>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TherapyService from '@/services/therapy.service';
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import Permission from '@/common/Permission';

export default {
    name: 'therapyListing',
    mixins: [DBFunctions, ShowMessage, Permission],

    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                Mode: this.edit_mode,
                favButtonAtion: false
            },
            parameter: {
                SearchCriteria: '',
                categoryCode: '',
                PageNumber: 0,
                PageSize: 0
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            fields: [
                { key: 'code', sortable: true, label: this.$t('Shared.Code'), class: 'text-left' },
                { key: 'name', sortable: true, label: this.$t('Shared.Name'), class: 'text-left' },
                {
                    key: 'categoryDescription',
                    sortable: true,
                    label: this.$t('Shared.Category'),
                    class: 'text-left'
                }
            ],
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            items: [],
            isReadOnly: false,
            ShowMessageIsEmpty: false,
            Mode: '',
            categoryName: ''
        };
    },

    methods: {
        AddTherapy() {
            this.Mode = 'Add';
            this.emitDataforFavorites();
            this.$emit('onUpdatedMenu', '');
            this.$router.push({ name: 'TherapyAdd' });
        },

        async getTherapy() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            await TherapyService.getAll(this.parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;
                        this.items.forEach(element => {
                            if (element.category && element.categoryName) {
                                element.categoryDescription = `[${element.category}] ${element.categoryName}`;
                            } else if (element.category) {
                                element.categoryDescription = `${element.category}`;
                            } else if (element.categoryName) {
                                element.categoryDescription = `${element.categoryName}`;
                            }
                        });

                        let headerString = response.headers['x-pagination'];
                        const header = JSON.parse(headerString);
                        this.totalRows = header.TotalCount;
                    }

                    this.showMessageIsEmpty = this.totalRows === 0;
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        EditTherapy(row) {
            this.Mode = 'Edit';
            this.$router.push({ name: 'TherapyEdit', params: { id: row.code } });
        },

        RemoveTherapy(row) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_cat'
                })
                .then(value => {
                    if (value) {
                        TherapyService.delete(row.code)
                            .then(() => {
                                this.currentPage = 1;
                                this.SearchTherapy();
                            })
                            .catch(error => {
                                this.showResponseErrorMessage(error);
                            });
                    }
                });
        },

        pageChanged(page) {
            this.currentPage = page;
            this.getTherapy();
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
            this.getTherapy();
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        onRowSelected(items) {
            this.selected = items;
        },

        SearchTherapy() {
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getTherapy();
        },

        onCodeConditionOk(result) {
            const type = result.FieldName;
            const { code } = result;

            const mapping = {
                category: { codeProp: 'categoryCode' }
            };

            const key = Object.keys(mapping).find(k => type.includes(k));

            if (key) {
                const { codeProp } = mapping[key];
                //this.therapy[codeProp] = code || '';
                //this[descProp] = description || '';
                this.parameter[codeProp] = code || '';
            }

            this.SearchTherapy();
        }
    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        this.$nextTick(() => {
            this.getTherapy();
        });
    }
};
</script>
